import React from 'react'
import Contactme from '../component/Contactme'


const Contact = () => {
  return (
    <div>
      <Contactme/>
    </div>
  )
}

export default Contact
